import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "counter", "submitButton", "selectAllCheckbox"]
  static values = { minEntries: Number, maxEntries: Number, editable: Boolean }

  connect() {
    this.updateState()
  }

  checkboxChanged() {
    this.updateState()
  }

  // Selects checkboxes in list order up to the max entries limit, since the
  // squad can hold more players than a match day sheet is allowed to name.
  toggleAll(event) {
    const shouldSelect = event.target.checked

    this.checkboxTargets.forEach((checkbox, index) => {
      checkbox.checked = shouldSelect && index < this.maxEntriesValue
    })

    this.updateState()
  }

  updateState() {
    const checkedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    const atLimit = checkedCount >= this.maxEntriesValue

    // Once locked, checkboxes are rendered disabled server-side and must stay
    // that way — otherwise this would re-enable them whenever atLimit is false.
    if (this.editableValue) {
      this.checkboxTargets.forEach((checkbox) => {
        if (!checkbox.checked) checkbox.disabled = atLimit
      })
    }

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${checkedCount} / ${this.maxEntriesValue} selected`
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = checkedCount < this.minEntriesValue
    }

    if (this.hasSelectAllCheckboxTarget) {
      const selectableCount = Math.min(this.checkboxTargets.length, this.maxEntriesValue)
      this.selectAllCheckboxTarget.checked = checkedCount > 0 && checkedCount >= selectableCount
      this.selectAllCheckboxTarget.indeterminate = checkedCount > 0 && checkedCount < selectableCount
    }
  }
}
